import React, { useState } from 'react';
import { Descriptions } from "antd";
import { find } from 'lodash';
import AppModalContainer from "@nxsys/components/AppModalContainer";
import AppDescription from "@nxsys/components/AppDescription";
import AppTagStatus from '@nxsys/components/AppTagStatus';
import { ClipBoardIcon } from '@nxsys/components/icons';
import { AppState } from '@nxsys/store';
import { AppDispatch } from '@nxsys/store';
import { useSelector } from 'react-redux';
import { formatMoney } from '@nxsys/utils/number-helper';
import { showCurrencyByCountry } from '@nxsys/utils';
import { useDispatch } from 'react-redux';
import { kidAction } from '@nxsys/store/slices/kid/kidSlice';
import {
  holidayPaymentMethodOptions,
  KIDEmailType,
  KIDEmailTypeEnum,
} from '@nxsys/constants/AppConstants';
import { showToast } from '@nxsys/utils/toast';
import PreviewModal from '../PreviewModal';

type DetailModalProps = {
	isOpen: boolean;
	toggle: () => void;
};

const DetailModal: React.FC<DetailModalProps> = ({
	isOpen,
	toggle,
}: DetailModalProps) => {

const { loading, kidHistoryDetail } = useSelector((state: AppState) => state.kid);
const { payrollCountry } = useSelector((state: AppState) => state.appStore);
const [previewHtml, setPreviewHtml] = useState<string | null>(null);
console.log("🚀 ~ kidHistoryDetail:", kidHistoryDetail)

const dispatch = useDispatch<AppDispatch>();
const handlePreview = async () => {
  const type =
    KIDEmailTypeEnum[kidHistoryDetail?.action as keyof typeof KIDEmailTypeEnum] ||
    'KID';
  const requestParams = {
    ...kidHistoryDetail?.dataSend?.data,
    type,
  };

  try {
    const response = await dispatch(
      kidAction.previewForUmbrella(requestParams),
    ).unwrap();
    setPreviewHtml(response?.data || '');
  } catch (error: any) {
    console.log('error', error);
    const errorMessage = error.message || `Failed to send email ${type}`;
    showToast({ type: 'error', message: errorMessage });
  }
};

  return (
    <>
      <AppModalContainer
        title={
          <>
            KID Details
            <AppTagStatus className="tag-popup Description">
              {
                KIDEmailType[
                  kidHistoryDetail?.action as keyof typeof KIDEmailType
                ]
              }
            </AppTagStatus>
          </>
        }
        isOpen={isOpen}
        toggle={toggle}
        actions={[
          {
            name: 'View Document',
            variant: 'outlined',
            buttonType: 'primary',
            icon: <ClipBoardIcon />,
            loading,
            onClick: () => {
              handlePreview();
            },
          },
        ]}
      >
        <AppDescription
          column={1}
          labelStyle={{ width: 216 }}
          bordered={false}
          colon={false}
          size="middle"
        >
          <Descriptions.Item label="Candidate Name">
            {kidHistoryDetail?.subcontractorName || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Company">
            {kidHistoryDetail?.dataSend?.companyName || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Agency">
            {kidHistoryDetail?.agency?.name || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Email ID">
            {kidHistoryDetail?.dataSend?.mailTo || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Pay Frequency">
            {kidHistoryDetail?.dataSend?.data?.payFrequency || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Pay Rate/Hours">
            {formatMoney(
              kidHistoryDetail?.dataSend?.data?.payRatePerHour,
              showCurrencyByCountry(payrollCountry),
            ) || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="No of Hours">
            {kidHistoryDetail?.dataSend?.data?.noOfHours || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Margin">
            {formatMoney(
              kidHistoryDetail?.dataSend?.data?.margin || 0,
              showCurrencyByCountry(payrollCountry),
            ) || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Tax Code">
            {kidHistoryDetail?.dataSend?.data?.taxCode || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Age">
            {kidHistoryDetail?.dataSend?.data?.age || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Expense">
            {formatMoney(
              kidHistoryDetail?.dataSend?.data?.expenses || 0,
              showCurrencyByCountry(payrollCountry),
            ) || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Holiday Pay Method">
            {find(
              holidayPaymentMethodOptions,
              (op) => op.value === kidHistoryDetail?.dataSend?.data?.holidayPayMethod,
            )?.label || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Pension">
            <span className="border h-[24px] w-[42px] text-center rounded bg-neutral-50">
              {kidHistoryDetail?.dataSend?.data?.pension ? 'Yes' : 'No'}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label="App Levy">
            <span className="border h-[24px] w-[42px] text-center rounded bg-neutral-50">
              {kidHistoryDetail?.dataSend?.data?.appLevy ? 'Yes' : 'No'}
            </span>
          </Descriptions.Item>
        </AppDescription>
      </AppModalContainer>
      <PreviewModal html={previewHtml} onClose={() => setPreviewHtml(null)} />
    </>
  );
};

export default DetailModal;